import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=cb24c3e0&lang=less"
import "./index.vue?vue&type=style&index=1&id=cb24c3e0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/sz-cd-pro4kg65/portal-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb24c3e0"]])

export default __exports__